import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {addOrUpdate, deleteRecord, getDB, getOldest} from "../util/indexedDBConnector";
import penniesAPI from "../integrations/pennies/Api"
import {saveIntegrationLog} from "../redux/actions";
import {getCurrentTimestamp} from "../util/calendar";

const syncLogs = (dispatch, state) => {
    let clientCode = state.rootReducer.user.clientCode;
    getDB(clientCode).then(() => {
        getOldest('saveIntegrationLog').then(({record, key, count}) => {
            if(record === null){
                return;
            }

            if(record.retries > (record?.maxRetries ?? 1440)){
                deleteRecord('saveIntegrationLog', key).then(() => {
                    syncLogs(dispatch, state);
                }, () => {
                    console.log("useIntegrationLogSync: could not delete saveTransaction record");
                });
                return;
            }

            if(record.application === "pennies"){
                penniesAPI.sendRequest(state, "POST", "donation", {retry:true}, record.requestData).then(() => {
                    deleteRecord('saveIntegrationLog', key).then(() => {
                        syncLogs(dispatch, state);
                    }, () => {
                        console.log("useIntegrationLogSync: could not delete saveTransaction record");
                    });
                }, () => {
                    dispatch(saveIntegrationLog(record.application, {
                        requestData: record.requestData,
                        status:0,
                        retries:0,
                        createdTime: getCurrentTimestamp()
                    }, false, false, false, (response) => {
                        deleteRecord('saveIntegrationLog', key).then(() => {
                            syncLogs(dispatch, state);
                        }, () => {
                            console.log("useIntegrationLogSync: could not delete saveTransaction record");
                        });
                    }, () => {
                        record.retries += 1;
                        addOrUpdate('saveIntegrationLog', record, key).then(() => {}, () => {});
                    }));
                });
            }
        }, () => {
            console.log('Could not get integration log records from the indexedDB');
        });
    });
}
export const useIntegrationLogSync = () => {
    const dispatch = useDispatch();
    const state = useSelector(state => state);
    const forceOffline = useSelector((state) => state.rootReducer.forceOffline);
    const connectionHealth = useSelector((state) => state.rootReducer.connectionHealth);
    const clientCode = useSelector((state => state?.rootReducer?.user?.clientCode ?? false));
    const erplyServiceEndpoints = useSelector((state => state?.rootReducer?.erplyServiceEndpoints ?? false));

    useEffect(() => {
        if(forceOffline || !connectionHealth || clientCode === false || erplyServiceEndpoints === false){
            return;
        }
        const sync = () => {
            if(connectionHealth){
                syncLogs(dispatch, state);
            }
        };
        sync();
        const healthStatus = window.setInterval(sync, 30 * 1000);
        return () => {
            window.clearInterval(healthStatus);
        };
    }, [clientCode, erplyServiceEndpoints]);
};
